import {
  boolean as yupBoolean,
  mixed,
  object as yupObject,
  ObjectSchemaDefinition,
  string as yupString,
  array as yupArray
} from "yup";

export function object<T extends object = {}>(
  fields?: ObjectSchemaDefinition<T>
) {
  return yupObject<T>(fields);
}

export function string(label: string) {
  return yupString().label(label);
}

export function constraints() {
  return yupObject({
    options: mixed().when("isArray", {
      is: Array.isArray,
      then: yupArray().of(yupString()),
      otherwise: undefined
    })
  }).default(undefined);
}

export function boolean(label: string) {
  return yupBoolean().label(label);
}

export function mixedObj(values: any, label: string) {
  return mixed()
    .label(label)
    .nullable()
    .oneOf([
      ...values.map((value: { value: string; key: string }) => value.value),
      null
    ])
    .notRequired();
}

export function slider(label: string) {
  return yupString().label(label);
}
